<template>
  <div class="finish-account text-center px-lg-3">
    <div v-if="submitted">
      <p class="text-center text-secondary">
        Obrigado por finalizar seu cadastro, aproveite a plataforma!
      </p>
      <button @click="$emit('close')" class="btn btn-primary px-5 mx-auto mt-5">
        Fechar
      </button>
    </div>
    <div v-else>
      <h5 class="mb-3">
        Responda essas perguntas para terminar de configurar sua conta.
      </h5>

      <h3 v-if="form" class="mb-2">
        {{ form.name }}
      </h3>

      <div
        class="mb-4"
        v-if="form && form.description"
        v-html="form.description"
      ></div>

      <div v-if="loading">
        <div class="d-flex justify-content-center px-lg-3 py-5">
          <div class="spinner-border text-primary" />
        </div>
      </div>

      <div v-else-if="form && answers.length" class="form-container text-start">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h2 v-html="form.asks[step].text"></h2>

            <form-group
              v-if="answersOptions[step] && answersOptions[step].length"
              :errors="answers[step].errors"
              v-model="answers[step].answer"
              type="radio"
              optionLabel="answer"
              :options="answersOptions[step]"
            />
            <form-group
              v-else
              v-model="answers[step].answer"
              :errors="answers[step].errors"
              placeholder="Resposta"
              textarea
              id="name"
            />
          </div>
        </div>

        <div class="row justify-content-center">
          <div v-if="step > 0" class="col-lg-5">
            <button
              @click="step--"
              class="btn btn-outline-primary px-lg-5 mx-auto mt-5"
            >
              Voltar
            </button>
          </div>
          <div class="col-lg-5">
            <button
              @click="submit"
              class="btn btn-primary px-lg-5 mx-lg-auto mt-5"
              :disabled="loading || !answers[step].answer"
            >
              <template v-if="loading">
                <div class="spinner-border text-primary" />
              </template>
              <template v-else>
                {{ btnLabel }}
              </template>
            </button>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="text-center text-secondary">
          Sem perguntas cadastradas no momento
        </p>
        <button
          @click="$emit('close')"
          class="btn btn-primary px-5 mx-auto mt-5"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import handlersMixin from "@/functions/mixins/handlers";
import { convertToPlain } from "@/functions/helpers";

export default {
  mixins: [handlersMixin],
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  data() {
    let answers = [];
    let answersOptions = [];
    if (this.form) {
      for (let k in this.form.asks) {
        answers[k] = {
          id: this.form.asks[k].id,
          answer: "",
        };

        let answ = [];
        this.form.asks[k].answers.map((item) => {
          answ.push({
            id: item.id,
            answer: item.answer,
          });
        });
        answersOptions[k] = answ;
      }
    }
    return {
      submitted: false,
      loading: false,
      answers,
      answersOptions,
      step: 0,
    };
  },
  computed: {
    btnLabel() {
      return this.step == this.form.asks.length - 1 ? "Enviar" : "Continuar";
    },
  },
  methods: {
    submit() {
      if (this.form.asks[this.step + 1]) {
        this.step++;
        return;
      }

      let missing_index = null;

      for (var k in this.form.asks) {
        if (!this.answers[k].answer) {
          missing_index = k;
          break;
        }
      }

      if (missing_index !== null) {
        this.$message.error(
          `Por favor preencha a pergunta: '${convertToPlain(
            this.form.asks[missing_index].text
          )}' antes de continuar`
        );
        return;
      }

      this.loading = true;

      this.$store
        .dispatch("user/answer_registrations_ask", {
          signature2user: this.$store.state.user.user.current_signature.id,
          registration: this.form.id,
          answers: {
            asks: this.answers,
          },
        })
        .then(() => {
          this.submitted = true;
        })
        .catch(this.handleErros)
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.finish-account {
  word-break: break-word;

  .form-container {
    padding: 20px 0px;
    @media screen and (min-width: 769px) {
      padding: 20px 60px;
    }

    .btn {
      min-width: 267px;

      @media (max-width: 768px) {
        min-width: 100%;
      }
    }
  }
}
</style>
